import * as React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import cx from 'classnames';

import { Video } from '../../../../components/Video/Video';
import { useMedia, REDUCED_MOTION_QUERY } from '../../../../utils/useMedia';
import { useDesktopClientOnly } from '../../../../utils/useDesktopClientOnly';

import * as cs from './HeroLayoutCover.module.css';

interface Props {
  coverImage?: Queries.BlogPostPageEntryFragment['coverImage'];
  coverVideo?: Queries.BlogPostPageEntryFragment['coverVideo'];
  coverVideoLoop?: boolean | null;
  logo?: string | null;
  title: string;
  socialCard?: boolean;
  largePlaceholder?: boolean | null;
}

export const HeroLayoutCover = ({
  coverImage,
  coverVideo,
  coverVideoLoop,
  logo,
  socialCard,
  title,
  largePlaceholder,
}: Props) => {
  const alt = `Cover for ${title}`;

  const isReducedMotion = useMedia(REDUCED_MOTION_QUERY);
  const desktopRendered = useDesktopClientOnly();
  const coverImageData = coverImage?.childImageSharp?.gatsbyImageData
    ? getImage(coverImage.childImageSharp.gatsbyImageData)
    : null;

  if (coverImage || coverVideo)
    return (
      <div
        className={cx(cs.cover, {
          [cs.noMargin]: socialCard,
        })}
      >
        {coverImageData && (
          <GatsbyImage
            className={cx(cs.image, cs.staticCoverImage, {
              [cs.hasVideo]: coverVideo && !socialCard,
            })}
            image={coverImageData}
            alt={alt}
            objectFit="contain"
            loading="eager"
          />
        )}
        {coverVideo && !socialCard && desktopRendered && !isReducedMotion && (
          <Video
            muted
            autoPlay
            loop={Boolean(coverVideoLoop)}
            controls={false}
            playsInline
            className={cx(cs.image, cs.videoCover)}
            sources={coverVideo.map((source) => ({
              src: source?.source?.publicURL,
              type: source?.codec,
            }))}
          />
        )}
      </div>
    );

  if (logo) {
    return (
      <img
        src={logo}
        alt={`${title} logo`}
        className={cx(cs.logo, {
          [cs.noMargin]: socialCard,
        })}
      />
    );
  }

  return (
    <div
      className={cx(cs.placeholder, {
        [cs.largePlaceholder]: largePlaceholder,
      })}
    />
  );
};
